import dayjs from "dayjs"
import utc from "dayjs/plugin/utc"

dayjs.extend(utc)

const mySqlToLocal = (date = null) => {
  return date
    ? dayjs.utc(date, "YYYY-MM-DD HH:mm:ss").local()
    : dayjs().local()
}

export default mySqlToLocal